/** Cycles a person through one of six brand-gradient avatar fills so a list
 * of connections reads as a diverse crowd rather than one repeated flat tone.
 * Deterministic per id/name — the same person always lands on the same tone. */
export function avatarGradient(seed: string): string {
  let hash = 0
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0
  }
  const index = (hash % 6) + 1
  return `var(--ds-avatar-grad-${index})`
}

/**
 * Maps a circle's `circleTypeID` to a visual identity — emoji glyph and a
 * CSS background color — so circle-picker modals and lists show a coherent
 * icon instead of the old CDN game-badge images.
 *
 * System type IDs from constants: Friends=1, Family=2, Colleagues=3,
 * Internal=4, Open Group=5.  Any unknown/custom type falls back gracefully.
 */
export interface CircleTypeStyle {
  emoji: string
  bg: string
  color: string
}

export function circleTypeStyle(circleTypeID: string | number): CircleTypeStyle {
  switch (String(circleTypeID)) {
    case '1': // Friends
      return { emoji: '🤝', bg: 'color-mix(in srgb, var(--ds-accent-dot-1) 22%, transparent)', color: 'var(--ds-accent-dot-1)' }
    case '2': // Family
      return { emoji: '❤️', bg: 'color-mix(in srgb, var(--ds-accent-deep-a, #e97a4a) 18%, transparent)', color: 'var(--ds-accent-deep-a, #e97a4a)' }
    case '3': // Colleagues / Work
      return { emoji: '💼', bg: 'color-mix(in srgb, var(--ds-accent-dot-4) 18%, transparent)', color: 'var(--ds-accent-dot-4)' }
    case '4': // Internal
      return { emoji: '🔒', bg: 'color-mix(in srgb, var(--ds-accent-deep-b, #8b5cf6) 18%, transparent)', color: 'var(--ds-accent-deep-b, #8b5cf6)' }
    case '5': // Open Group
      return { emoji: '🌐', bg: 'color-mix(in srgb, var(--ds-accent-dot-5) 22%, transparent)', color: 'var(--ds-accent-dot-5)' }
    default:  // Custom / unknown
      return { emoji: '◉', bg: 'var(--ds-hover)', color: 'var(--ds-ink-subtle)' }
  }
}
